import Event from "../../entities/event";

/**
 * Event actions
 *
 * Call order:
 *
 * EVENT_SAVE_QUEUE:	adds the item to the save queue
 * --> EVENT_SAVE:	modifies the state
 * --> EVENT_SAVE_SUCCESS: if all went well
 * --> EVENT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail EVENT_SAVE_QUEUE is during the call to EVENT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const EVENT_FETCH_ONE_QUEUE: any = 'EVENT_FETCH_ONE_QUEUE';
export const EVENT_FETCH_SUCCESS: any = 'EVENT_FETCH_SUCCESS';
export const EVENT_FETCH_FAILURE: any = 'EVENT_FETCH_FAILURE';
export const EVENT_FETCH_ONE_SUCCESS: any = 'EVENT_FETCH_ONE_SUCCESS';
export const EVENT_FETCH_ONE_FAILURE: any = 'EVENT_FETCH_ONE_FAILURE';

export const EVENT_SAVE: any = 'EVENT_SAVE';
export const EVENT_SAVE_QUEUE: any = 'EVENT_SAVE_QUEUE';
export const EVENT_SAVE_SUCCESS: any = 'EVENT_SAVE_SUCCESS';
export const EVENT_SAVE_FAILURE: any = 'EVENT_SAVE_FAILURE';

export const EVENT_SAVE_MANY: any = 'EVENT_SAVE_MANY';
export const EVENT_SAVE_MANY_QUEUE: any = 'EVENT_SAVE_MANY_QUEUE';
export const EVENT_SAVE_MANY_SUCCESS: any = 'EVENT_SAVE_MANY_SUCCESS';
export const EVENT_SAVE_MANY_FAILURE: any = 'EVENT_SAVE_MANY_FAILURE';

export const EVENT_REMOVE: any = 'EVENT_REMOVE';
export const EVENT_REMOVE_QUEUE: any = 'EVENT_REMOVE_QUEUE';
export const EVENT_REMOVE_SUCCESS: any = 'EVENT_REMOVE_SUCCESS';
export const EVENT_REMOVE_FAILURE: any = 'EVENT_REMOVE_FAILURE';

export const EVENT_RESTORE: any = 'EVENT_RESTORE';
export const EVENT_RESTORE_QUEUE: any = 'EVENT_RESTORE_QUEUE';
export const EVENT_RESTORE_SUCCESS: any = 'EVENT_RESTORE_SUCCESS';
export const EVENT_RESTORE_FAILURE: any = 'EVENT_RESTORE_FAILURE';

export const EVENT_RESTORE_MANY: any = 'EVENT_RESTORE_MANY';
export const EVENT_REMOVE_MANY: any = 'EVENT_REMOVE_MANY';

/* Fetch actions */
export const fetchEventSuccess = (events: Event[], partial: boolean, lastFetch: number) => ({type: EVENT_FETCH_SUCCESS, events, partial, lastFetch});
export const fetchEventFailure = (err: any) => {
		console.error('EventAction: fetchEventFailure', err);
		return {type: EVENT_FETCH_FAILURE, err};
};
export const fetchOneEventQueue = (eventId: string) => ({type: EVENT_FETCH_ONE_QUEUE, eventId});
export const fetchOneEventSuccess = (event: Event) => ({type: EVENT_FETCH_ONE_SUCCESS, event});
export const fetchOneEventFailure = (id: string, err: any) => {
		console.error('EventAction: fetchOneEventFailure', err);
		return {type: EVENT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveEvent = (event: Event) => {
    // console.debug('⮂ EVENT_SAVE action', event?.id);
    return {type: EVENT_SAVE, event};
}
export const saveEventQueue = (event: Event) => {
    // console.debug('⮂ EVENT_SAVE_QUEUE action', event?.id);
    return {type: EVENT_SAVE_QUEUE, event};
}
export const saveEventSuccess = (event: Event) => {
    // console.debug('⮂ EVENT_SAVE_SUCCESS action', event?.id);
    return {type: EVENT_SAVE_SUCCESS, event};
}
export const saveEventFailure = (event: Event, status: number, message: string) => {
    console.warn(`⮂ EVENT_SAVE_FAILURE error saving event: HTTP ${status}: ${message}`, event?.id);
    return {type: EVENT_SAVE_FAILURE, event, status, message};
};

/* SaveMany actions */
export const saveManyEvents = (events: Event[]) => {
    // console.debug('⮂ EVENT_SAVE_MANY action', events?.map(event => event?.id).join(','));
    return {type: EVENT_SAVE_MANY, events};
}
export const saveManyEventsQueue = (events: Event[]) => {
    // console.debug('⮂ EVENT_SAVE_MANY_QUEUE action', events?.map(event => event.id).join(','));
    return {type: EVENT_SAVE_MANY_QUEUE, events};
}

export const saveManyEventsSuccess = (events: Event[]) => {
    // console.debug('⮂ EVENT_SAVE_MANY_SUCCESS action', events?.map(event => event.id).join(','));
    return {type: EVENT_SAVE_MANY_SUCCESS, events};
}
export const saveManyEventsFailure = (events: Event[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_EVENTS_FAILURE Error saving events: HTTP ${status}: ${message}`, events?.map(event => event.id).join(','));
		return {type: EVENT_SAVE_MANY_FAILURE, events, status, message};
};

/* Remove actions */
export const removeEvent = (event: Event) => ({ type: EVENT_REMOVE, event });
export const removeEventQueue = (event: Event) => ({ type: EVENT_REMOVE_QUEUE, event });
export const removeEventSuccess = (event: Event) => ({ type: EVENT_REMOVE_SUCCESS, event });
export const removeEventFailure = (event: Event, status: number, message: string) => {
	console.error(`Redux: removeEventFailure Error removing event: HTTP ${status}: ${message}`);
	return ({ type: EVENT_REMOVE_FAILURE, event, status, message });
};

/* Restore actions */
export const restoreEvent = (event: Event) => ({ type: EVENT_RESTORE, event });
export const restoreEventQueue = (event: Event) => ({ type: EVENT_RESTORE_QUEUE, event });
export const restoreEventSuccess = (event: Event) => ({ type: EVENT_RESTORE_SUCCESS, event });
export const restoreEventFailure = (event: Event, status: number, message: string) => {
	console.error(`Redux: restoreEventFailure Error restoring event: HTTP ${status}: ${message}`);
	return ({ type: EVENT_RESTORE_FAILURE, event, status, message });
};

/* RestoreMany actions */
export const restoreManyEvents = (events: Event[]) => ({ type: EVENT_RESTORE_MANY, events });

/* RemoveMany actions */
export const removeManyEvents = (events: Event[]) => ({ type: EVENT_REMOVE_MANY, events });